import { createReducer } from '@reduxjs/toolkit';
import { RequestError, State } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { sendEmail, sendedEmail, updatePassword, updatedPassword } from './actions';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  message: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(sendEmail, (state) => {
      state.status = 'loading';
    })
    .addCase(updatePassword, (state) => {
      state.status = 'loading';
    })
    .addCase(sendedEmail, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.status = 'error';
        state.error = payload as RequestError;
      } else {
        state.status = 'success';
        state.error = undefined;
      }
    })
    .addCase(updatedPassword, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.status = 'error';
        state.error = payload?.error as RequestError;
        state.message = payload?.message as string;
      } else {
        state.status = 'success';
        state.error = undefined;
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'ResetPassword') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
